import React, { useContext } from "react";
import { GlobalContext } from "./../Context";
import { CountrySelection } from "../CountrySelection";
import logoBAC from "../../../assets/img/bac-logo.svg";
import "./Sidebar.scss";

const Sidebar = (props) => {
  const globalContext = useContext(GlobalContext);
  const {
    resultsState,
    filtersVisibility,
    branchSchedulesVisibility,
  } = globalContext;

  return (
    <div
      className={`sidebar ${resultsState ? "sidebar--results" : ""} ${
        branchSchedulesVisibility && !resultsState
          ? "sidebar--branch-schedule"
          : ""
      }`}
    >
      <div className="sidebar__heading">
        <img className="sidebar__logo" src={logoBAC} alt="BAC Logo" />
        <div className="sidebar__divider" />
        <div className="sidebar__title">Ubícanos</div>
        <div className="sidebar__country_selection">
          <CountrySelection />
        </div>
      </div>
      <div
        className={`sidebar__content ${
          filtersVisibility ? "sidebar__content--filters" : ""
        }`}
      >
        {props.children}
      </div>
    </div>
  );
};

export default Sidebar;
